module.exports = __webpack_public_path__ + "img/p2-p3-tips.905ccfaa.png";